<template>
  <div
    class="el-checkbox-group"
    :class="{
      'is-invalid': isInvalid
    }"
    role="group"
    aria-label="checkbox-group"
  >
    <div class="el-checkbox-group__content">
      <slot />
    </div>
  </div>
</template>

<script>
  import Emitter from '@uikit/ui-kit/src/mixins/emitter';
  import Size from '@uikit/ui-kit/src/mixins/size';

  export default {
    name: 'ElCheckboxGroup',

    componentName: 'ElCheckboxGroup',

    mixins: [
      Emitter,
      Size
    ],

    inject: {
      elFormItem: {
        default: {}
      }
    },

    props: {
      value: {},
      disabled: Boolean,
      min: Number,
      max: Number
    },

    computed: {
      isInvalid() {
        return this.elFormItem.validateState === 'error';
      }
    },

    watch: {
      value(value) {
        this.dispatch('ElFormItem', 'el.form.change', [value]);
        this.dispatch('ElFormItem', 'el.form.input', [value]);
      }
    },

    created() {
      this.$on('handleChange', (value) => {
        this.$emit('change', value);
      });
    }
  };
</script>
